import { useQuery } from '@tanstack/react-query';
import {SuggestedTemperature} from "@/types/sensors";
import {sensorsService} from "@/services/sensors";


export const useSuggestedTemperature = () => {
  return useQuery<SuggestedTemperature, Error>({
    queryKey: ['suggested-temperature'],
    queryFn: sensorsService.getSuggestedTemperature,
    staleTime: 2 * 60 * 1000,
    gcTime: 5 * 60 * 1000,
    refetchInterval: 5 * 60 * 1000,
  });
};